module.exports = __webpack_public_path__ + "img/florian_gramuller.748b4249.png";